import Button from "@mui/material/Button";

export default function LoadBtn({
  loading = false,
  variant = "contained",
  fullWidth = false,
  size = "large",
  type = "submit",
  text = "confirm",
  handle,
  onClick,
  disabled,
  sx = {},
  ...rest
}) {
  return (
    <Button
      loading={loading}
      disabled={disabled || loading}
      variant={variant}
      fullWidth={fullWidth}
      size={size}
      type={type}
      onClick={handle || onClick}
      sx={{ textTransform: "capitalize", ...sx }}
      {...rest}
    >
      {text}
    </Button>
  );
}
